export const pt = {
  meta: {
    title: 'AuthFlow™ - Autenticação simples por email/senha com tokens JWT',
    description: 'Autenticação confiável por email/senha com tokens JWT para aplicações web modernas. Ao contrário de plataformas complexas, focamos no que funciona: um login seguro e simples em que os desenvolvedores podem confiar.',
  },
  // Navigation
  nav: {
    home: 'Início',
    features: 'Recursos',
    pricing: 'Preços',
    compare: 'Comparar',
    contact: 'Contato',
    getStarted: 'Começar',
    signIn: 'Entrar',
  },

  // Dashboard
  dashboard: {
    title: 'Painel',
    users: 'Usuários',
    activity: 'Atividade',
    settings: 'Configurações',
    logout: 'Sair',
    profileSettings: 'Configurações de perfil',
    activityLog: 'Registro de atividades',
    welcome: 'Bem-vindo ao seu painel',
    welcomeBack: 'Bem-vindo de volta, {name}. Aqui está o que está acontecendo com seu serviço de autenticação.',
    totalUsers: 'Total de usuários',
    activeUsers: 'Usuários ativos',
    totalLogins: 'Total de logins',
    recentActivity: 'Atividade recente',
    noRecentActivity: 'Sem atividade recente',
    userSettings: 'Configurações do usuário',
    organizationOwnerCannotBeManaged: 'O proprietário da organização não pode ser gerenciado',
    configureSettings: 'Configurar ajustes',
    hereIsWhatsHappening: 'Aqui está o que está acontecendo com seu serviço de autenticação.',
    fromLastMonth: 'em relação ao mês passado',
    monthlyLogins: 'Logins mensais',
    successRate: 'Taxa de sucesso',
    latestAuthEvents: 'Últimos eventos de autenticação e atualizações do sistema',
    viewAllActivity: 'Ver toda atividade',
    userManagement: 'Gerenciamento de usuários',
    manageApplicationUsers: 'Gerencie os usuários da sua aplicação',
    viewAllUsers: 'Ver todos os usuários',
    apiKeys: 'Chaves de API',
    manageApiKeys: 'Gerencie suas chaves de API de autenticação',
    systemStatus: 'Status do sistema',
    authenticationApi: 'API de autenticação',
    operational: 'Operacional',
    userManagementService: 'Gerenciamento de usuários',
    searchUsers: 'Buscar usuários...',
    all: 'Todos',
    active: 'Ativo',
    inactive: 'Inativo',
    lastLogin: 'Último login',
    never: 'Nunca',
    admin: 'Administrador',
    owner: 'Proprietário',
    noUsersFound: 'Nenhum usuário encontrado para seus critérios',
    noUsers: 'Nenhum usuário encontrado',
    for: 'para',
    noApiKeyFound: 'Nenhuma chave de API encontrada',
    hideApiKey: 'Ocultar chave de API',
    showApiKey: 'Mostrar chave de API',
    created: 'Criado',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',
    system: 'Sistema',
    justNow: 'agora mesmo',
    minutesAgo: 'minutos atrás',
    hoursAgo: 'horas atrás',
    daysAgo: 'dias atrás',
    notifications: 'Notificações',
    billingReminder: 'Lembrete de cobrança',
    noNewNotifications: 'Sem novas notificações',
    logOut: 'Sair',
  },

  // Hero Section
  hero: {
    badge: 'Confiado por times DevSecOps no mundo todo',
    title: 'Autenticação',
    subtitle: 'Feita do jeito certo',
    description: 'A melhor, mais rápida e mais segura autenticação por email e senha disponível. Diferente de plataformas excessivamente complexas, focamos no que importa: autenticação JWT segura que simplesmente funciona.',
    startTrial: 'Iniciar teste grátis',
    getStarted: 'Começar',
    trialNote: 'Sem cartão de crédito • 10 Usuários Ativos Mensais Grátis',
    metrics: {
      firstIntegrationValue: '5 min',
      firstIntegrationLabel: 'até a primeira integração',
      predictableSessionsValue: 'JWT',
      predictableSessionsLabel: 'sessões que permanecem previsíveis',
      noMazeValue: 'Sem labirinto',
      noMazeLabel: 'para times que só precisam que auth funcione',
    },
    missionControlLabel: 'Centro de controle de auth',
    missionControlTitle: 'Autenticação de usuários, sem labirinto',
    missionControlStatus: 'Estável',
    sessionLayer: 'Camada de sessão',
    emailPasswordSignIn: 'Login por email/senha',
    roleAwareVerification: 'Verificação orientada por função',
    validated: 'validado',
    live: 'ao vivo',
    integrationShapeLabel: 'Formato de integração',
    integrationShapeValue: 'API pequena, fluxo claro',
    forTeamsLabel: 'Para times',
    forTeamsValue: 'Entregando produto, não projetos IAM',
  },

  // Features
  features: {
    title: 'Por que o AuthFlow™ é diferente',
    description: 'Focamos em autenticação por email/senha com tokens JWT, a base de apps web seguros. Em vez de tentar fazer tudo, fazemos uma coisa excepcionalmente bem.',
    emailPassword: {
      title: 'Login com email/senha',
      description: 'Autenticação simples e segura por email e senha, com funcionamento confiável. Sem fluxos complexos nem recursos desnecessários.',
    },
    jwtTokens: {
      title: 'Gerenciamento de tokens JWT',
      description: 'Tratamento correto de tokens JWT para sessões, com armazenamento seguro e renovação automática. Tokens padrão de mercado com integração fluida com sua API.',
    },
    developerApi: {
      title: 'API voltada para desenvolvedores',
      description: 'API REST com documentação completa, SDKs e ferramentas para desenvolvedores. Criada por devs para o fluxo DevSecOps.',
    },
  },

  // Testimonials
  testimonials: {
    title: 'Confiado por desenvolvedores no mundo todo',
    testimonial1: {
      text: 'O AuthFlow™ economizou meses de desenvolvimento para nós. A integração foi perfeita e os recursos de segurança têm nível empresarial.',
      author: 'Sarah Johnson',
      role: 'CTO, TechStart',
    },
    testimonial2: {
      text: 'O painel analítico nos dá insights incríveis sobre o comportamento dos usuários. A melhor solução de autenticação que já usamos.',
      author: 'Mike Rodriguez',
      role: 'Lead Developer, AppCorp',
    },
    testimonial3: {
      text: 'Confiabilidade sólida e excelente suporte. Nossos usuários adoram a experiência de autenticação fluida.',
      author: 'Alex Liu',
      role: 'Product Manager, InnovateLab',
    },
  },

  // CTA Section
  cta: {
    title: 'Pronto para adicionar autenticação confiável?',
    description: 'Junte-se aos desenvolvedores que escolhem autenticação simples e eficaz por email/senha com tokens JWT. Comece seu teste grátis hoje.',
    startTrial: 'Iniciar teste grátis',
  },

  // About Page
  about: {
    title: 'Sobre o AuthFlow™ - Especialistas em autenticação simples por email/senha',
    description: 'Conheça a missão do AuthFlow™ de fornecer autenticação confiável por email/senha com tokens JWT. Fundada em 2023, tornamos login seguro simples para todo desenvolvedor.',
    keywords: [
      'autenticação por email e senha',
      'empresa de autenticação JWT',
      'especialistas em autenticação',
      'autenticação simples',
      'empresa de login seguro',
      'autenticação para desenvolvedores',
      'autenticação confiável',
      'autenticação baseada em token',
      'segurança para aplicações web',
      'plataforma de autenticação'
    ],
    ogTitle: 'Sobre o AuthFlow™ - Especialistas em autenticação simples por email/senha',
    ogDescription: 'Conheça nossa missão de oferecer autenticação confiável por email/senha com JWT. Em vez de complexidade, focamos no que funciona.',
    hero: {
      badge: 'Fundada em 2023',
      title: 'Construindo o futuro da',
      titleAccent: 'autenticação simples',
      description: 'Nossa missão é tornar a autenticação por email/senha com tokens JWT acessível a todo desenvolvedor, eliminando complexidade e riscos de segurança de construir auth do zero.',
    },
    mission: {
      title: 'Nossa missão',
      description1: 'Democratizar autenticação segura baseada em tokens, simples de implementar e manter. Acreditamos que toda aplicação merece autenticação confiável por email/senha com JWT, sem a dor de plataformas superengenheiradas.',
      description2: 'Priorizamos privacidade e conformidade por padrão, minimizando coleta de dados, criptografando informações sensíveis em repouso e em trânsito e oferecendo políticas de retenção configuráveis.',
      description3: 'Ao abstrair a complexidade de protocolos superengenheirados e gestão de usuários, permitimos que desenvolvedores foquem no que fazem melhor: construir produtos incríveis com autenticação confiável.',
    },
    vision: {
      title: 'Nossa visão',
      description1: 'Um mundo em que autenticação é simples e confiável. Vemos um futuro onde toda aplicação web tenha acesso a autenticação confiável por email/senha com JWT, sem complexidade desnecessária.',
      description2: 'Com inovação contínua e desenvolvimento guiado pela comunidade, estamos construindo uma infraestrutura de autenticação focada no essencial: login seguro e simples.',
    },
    values: {
      title: 'Nossos valores',
      subtitle: 'Os princípios que guiam tudo o que fazemos no AuthFlow™.',
      reliableSecurity: {
        title: 'Segurança confiável',
        description: 'Focamos em práticas de segurança comprovadas. Autenticação por email/senha com gerenciamento correto de JWT, sem complexidade desnecessária.',
      },
      developerFirst: {
        title: 'API orientada ao desenvolvedor',
        description: 'Temos obsessão por uma ferramenta intuitiva, bem documentada e agradável de usar. Uma ótima experiência dev resulta em produtos melhores e mais seguros.',
      },
      communityDriven: {
        title: 'Guiado pela comunidade',
        description: 'Nosso roadmap é moldado por você, desenvolvedor-cliente. Ouvimos, aprendemos e construímos com base em necessidades reais de segurança.',
      },
    },
    team: {
      title: 'Conheça nosso time',
      subtitle: 'As pessoas apaixonadas que constroem o futuro da autenticação.',
      alex: {
        initials: 'AJ',
        name: 'Alex Johnson',
        role: 'CEO e cofundador',
        bio: 'Ex-profissional de DevSecOps em uma grande instituição financeira multinacional dos EUA. Apaixonado por tornar autenticação confiável acessível a todos os desenvolvedores.',
      },
      sarah: {
        initials: 'SC',
        name: 'Sarah Chen',
        role: 'CTO e cofundadora',
        bio: 'Arquiteta full stack com mais de 10 anos construindo sistemas de autenticação confiáveis. Especialista em autenticação por email/senha e gestão de tokens JWT.',
      },
      marcus: {
        initials: 'MR',
        name: 'Marcus Rodriguez',
        role: 'Head de produto',
        bio: 'Líder de produto focado em experiência de desenvolvedor e autenticação confiável. Especialista em sistemas de login simples e eficazes.',
      },
    },
    stats: {
      title: 'AuthFlow™ em números',
      developers: 'Desenvolvedores confiam em nós',
      authentications: 'Autenticações mensais',
      uptime: 'Disponibilidade',
      monitoring: 'Monitoramento de segurança',
    },
    cta: {
      title: 'Junte-se à nossa missão',
      description: 'Pronto para fazer parte da revolução da autenticação? Comece hoje com autenticação confiável por email/senha.',
      getStarted: 'Começar grátis',
      contactUs: 'Fale conosco',
    },
    breadcrumb: {
      company: 'Empresa',
      aboutUs: 'Sobre nós',
    },
  },

  // Sign In Page
  signIn: {
    title: 'Bem-vindo de volta',
    subtitle: 'Entre na sua autenticação por email/senha',
    card: {
      title: 'Login da organização',
      description: 'Digite o email do proprietário da organização para acessar o painel de autenticação JWT',
    },
    form: {
      email: {
        label: 'Email',
        placeholder: 'owner@yourorganization.com',
      },
      password: {
        label: 'Senha',
        placeholder: 'Digite sua senha',
      },
      signIn: 'Entrar',
      signingIn: 'Entrando...',
      noAccount: {
        text: 'Não tem uma organização?',
        link: 'Crie uma',
      },
    },
    errors: {
      emailRequired: 'Email é obrigatório',
      failed: 'Falha ao entrar',
      unexpected: 'Ocorreu um erro inesperado. Tente novamente.',
    },
    success: {
      message: 'Login realizado com sucesso!',
    },
    agreement: {
      text: 'Ao entrar, você concorda com nossos',
      terms: 'Termos de serviço',
      and: 'e',
      privacy: 'Política de privacidade',
    },
  },

  // Sign Up
  signUp: {
    title: 'Crie sua organização',
    subtitle: 'Inicie sua organização com autenticação por email/senha',
    card: {
      title: 'Criar organização',
      description: 'Configure sua organização para começar com autenticação por email/senha e tokens JWT',
    },
    form: {
      organizationName: {
        label: 'Nome da organização',
        placeholder: 'Sua organização',
      },
      organizationWebsite: {
        label: 'Site da organização',
        placeholder: 'yourorganization.com',
      },
      emailOwner: {
        label: 'Email do proprietário',
        placeholder: 'owner@yourorganization.com',
      },
      password: {
        label: 'Senha',
        placeholder: 'Crie uma senha forte',
      },
      confirmPassword: {
        label: 'Confirmar senha',
        placeholder: 'Confirme sua senha',
      },
      agreeToTerms: 'Concordo com os Termos de serviço e a Política de privacidade',
      acceptMarketing: 'Envie atualizações de produto e emails de marketing',
      createOrganization: 'Criar organização',
      creatingOrganization: 'Criando organização...',
      haveAccount: {
        text: 'Já tem uma conta?',
        link: 'Entrar',
      },
    },
    errors: {
      organizationNameRequired: 'Nome da organização é obrigatório',
      organizationWebsiteRequired: 'Site da organização é obrigatório',
      emailRequired: 'Email é obrigatório',
      passwordRequired: 'Senha é obrigatória',
      passwordsDoNotMatch: 'As senhas não coincidem',
      agreeToTermsRequired: 'Você deve concordar com os Termos de serviço e a Política de privacidade',
      failed: 'Falha ao criar organização',
      unexpected: 'Ocorreu um erro inesperado. Tente novamente.',
    },
    success: {
      message: 'Organização criada com sucesso!',
    },
    trial: {
      description: 'Comece a gerenciar a autenticação da sua organização hoje.',
      features: {
        emailPassword: 'Autenticação por email/senha',
        jwtTokens: 'Segurança com tokens JWT',
        simpleLogin: 'Login simples',
      },
    },
  },

  // Pricing Page
  pricing: {
    title: 'Preços do AuthFlow™ - Custos simples de autenticação por email/senha',
    description: 'Preços simples e transparentes para autenticação por email/senha com tokens JWT. Comece grátis e escale conforme cresce. Sem taxas ocultas.',
    keywords: [
      'preços de autenticação',
      'preços email e senha',
      'preços JWT',
      'preços de autenticação simples',
      'preços de autenticação para desenvolvedores',
      'custos de autenticação confiável',
      'preços de login seguro',
      'preços de autenticação baseada em token',
      'teste grátis de autenticação'
    ],
    ogTitle: 'Preços do AuthFlow™ - Custos simples de autenticação por email/senha',
    ogDescription: 'Escolha o plano ideal para suas necessidades. Comece grátis e escale com autenticação confiável por email/senha e JWT.',
    hero: {
      title: 'Preços simples e',
      titleAccent: 'transparentes',
      description: 'Escolha o plano ideal para sua autenticação. Comece grátis e escale com autenticação por email/senha via tokens JWT de sessão.',
    },
    breadcrumb: {
      product: 'Produto',
      pricing: 'Preços',
    },
    plans: {
      starter: {
        name: 'Inicial',
        description: 'Perfeito para projetos pequenos e testes de autenticação por email/senha',
        price: '$0',
        period: '/month',
        features: {
          users: 'Até 10 usuários ativos mensais',
          basicAuth: 'Autenticação básica por email/senha',
          support: 'Suporte padrão',
        },
        cta: 'Começar grátis',
      },
      pro: {
        name: 'Pro',
        description: 'Para empresas em crescimento que precisam de autenticação confiável',
        price: '$9.99',
        period: 'primeiro mês, depois $19.99/mês',
        badge: 'Mais popular',
        features: {
          users: 'Usuários ativos mensais ilimitados',
          advancedAuth: 'Autenticação avançada por email/senha',
          support: 'Suporte prioritário',
        },
        cta: 'Iniciar teste grátis',
        monthlyCta: 'Comprar mensal',
        annualCta: 'Comprar anual',
      },
    },
    faq: {
      title: 'Perguntas frequentes',
      subtitle: 'Tudo o que você precisa saber sobre nossos planos e preços.',
      questions: {
        mau: {
          question: 'O que conta como usuário ativo mensal?',
          answer: 'Um usuário ativo mensal (MAU) é um usuário único que se autentica no seu aplicativo ao menos uma vez no mês calendário.',
        },
        changePlans: {
          question: 'Posso mudar de plano a qualquer momento?',
          answer: 'Sim, você pode subir ou descer de plano a qualquer momento. As mudanças entram em vigor imediatamente e a cobrança é proporcional.',
        },
        freeTrial: {
          question: 'Há teste grátis?',
          answer: 'Sim, todos os planos pagos incluem 3 dias de teste grátis. Sem cartão de crédito para começar.',
        },
        paymentMethods: {
          question: 'Quais formas de pagamento vocês aceitam?',
          answer: 'Aceitamos os principais cartões de crédito, Google Pay e Apple Pay.',
        },
      },
    },
    cta: {
      title: 'Pronto para começar?',
      description: 'Junte-se a milhares de desenvolvedores que confiam no AuthFlow™ para autenticação confiável por email/senha.',
      startTrial: 'Iniciar teste grátis',
      contactSales: 'Falar com vendas',
    },
    footer: {
      description: 'Autenticação simples e confiável por email/senha com tokens JWT. Confiado por desenvolvedores no mundo todo.',
      product: {
        title: 'Produto',
        features: 'Recursos',
        pricing: 'Preços',
        apiReference: 'Referência da API',
      },
      resources: {
        title: 'Recursos',
        gettingStarted: 'Primeiros passos',
        apiReference: 'Referência da API',
        support: 'Suporte',
      },
      company: {
        title: 'Empresa',
        about: 'Sobre',
        privacy: 'Política de privacidade',
        terms: 'Termos de serviço',
      },
      copyright: '© 2024 AuthFlow™. Todos os direitos reservados.',
    },
  },

  // Get Started Page
  getStarted: {
    title: 'AuthFlow™ Primeiros passos - Guia de implementação de autenticação por email/senha | Integração API JWT',
    description: 'Guia completo para implementar autenticação por email/senha com AuthFlow™. Configure tokens JWT para login seguro em minutos.',
    keywords: [
      'configuração de autenticação',
      'autenticação por email e senha',
      'integração JWT',
      'guia de login seguro',
      'autenticação para desenvolvedores',
      'tutorial de API de autenticação',
      'autenticação baseada em token',
      'guia de API de autenticação'
    ],
    ogTitle: 'AuthFlow™ Primeiros passos - Guia de implementação de autenticação por email/senha | Integração API JWT',
    ogDescription: 'Guia completo para implementar autenticação por email/senha com AuthFlow™. Configure JWT para login seguro em minutos.',
    breadcrumb: {
      resources: 'Recursos',
      getStarted: 'Primeiros passos',
    },
    hero: {
      badge: 'Guia rápido de configuração',
      title: 'Comece com',
      titleAccent: 'autenticação por email/senha',
      description: 'Adicione login seguro por email/senha ao seu app em minutos, usando autenticação JWT da nossa plataforma.',
      createAccount: 'Criar conta grátis',
    },
    steps: {
      title: 'Três passos simples para autenticação segura por email/senha',
      subtitle: 'Siga estes passos para integrar os endpoints de autenticação do AuthFlow™ no seu backend.',
      step1: {
        number: '1',
        title: 'Crie sua conta',
        description: 'Cadastre-se no AuthFlow™ e crie seu primeiro projeto. Você receberá sua chave de API do servidor imediatamente.',
        signUp: 'Cadastrar grátis',
        viewDemo: 'Ver demonstração',
      },
      step2: {
        number: '2',
        title: 'Integre os endpoints de autenticação',
        description: 'Use nossos endpoints /auth no backend para autenticar usuários. Todos exigem a chave de API da organização.',
        features: {
          apiKeyRequired: 'API key obrigatória',
          apiKeyDescription: 'Todos os endpoints /auth exigem a API key da organização em tokens JWT',
          backendIntegration: 'Integração de backend',
          backendDescription: 'Chame do código servidor; nunca exponha API keys no frontend',
          sessionManagement: 'Gerenciamento de sessão',
          sessionDescription: 'Gerencie sessões com tokens JWT para autenticação confiável',
        },
      },
      step3: {
        number: '3',
        title: 'Adicione autenticação',
        description: 'Envolva seu app com seu provider e comece a usar componentes de autenticação.',
        quickStart: 'Início rápido',
        fullDocumentation: 'Documentação completa',
      },
    },
    apiDocs: {
      title: 'Guia técnico de endpoints da API /auth para autenticação por email/senha',
      subtitle: 'Documentação técnica completa para integrar os endpoints do AuthFlow™ ao seu backend.',
      apiKeySetup: {
        title: 'Configuração da API key',
        description: 'A API key da organização é incorporada em todos os tokens JWT dos endpoints /auth. Armazene com segurança nas variáveis de ambiente do backend.',
        envVars: '# Variáveis de ambiente',
        apiKeyVar: 'AUTHFLOW_API_KEY=af_your_api_key_here',
        baseUrlVar: 'AUTHFLOW_BASE_URL=https://api.authflow.net',
        securityNote: 'Nota de segurança: nunca exponha sua API key no frontend ou em JavaScript do cliente. Todas as chamadas /auth devem ser feitas no backend.',
      },
      endpoints: {
        foobar: {
          title: 'GET /auth/fooBar',
          description: 'Gera tokens temporários antiabuso para fluxos de autenticação',
          params: 'Parâmetros:',
          identityParam: 'identity (string): endereço de email do usuário',
          response: 'Resposta:',
          example: 'Exemplo Node.js:',
        },
        signUp: {
          title: 'POST /auth/signUp',
          description: 'Cria novas contas de usuário dentro da sua organização',
          params: 'Parâmetros:',
          foobarParam: 'foobar (string): token vindo de /auth/fooBar',
          apiKeyParam: 'api_key (string): API key da sua organização',
          emailParam: 'email (string): endereço de email do usuário',
          passwordParam: 'password (string): senha do usuário (8-32 chars, maiúscula, minúscula, número, caractere especial)',
          fullnameParam: 'fullname (string): nome completo do usuário',
          disclaimedParam: 'disclaimed (string): deve ser "true"',
          response: 'Resposta:',
          example: 'Exemplo Node.js:',
        },
        login: {
          title: 'POST /auth/login',
          description: 'Autentica usuários e retorna tokens de sessão',
          params: 'Parâmetros:',
          foobarParam: 'foobar (string): token vindo de /auth/fooBar',
          emailParam: 'email (string): endereço de email do usuário',
          passwordParam: 'password (string): senha do usuário',
          apiKeyParam: 'api_key (string): Organization API key',
          response: 'Resposta:',
          tokenNote: 'O JWT retornado contém o contexto do usuário autenticado',
          example: 'Exemplo Node.js:',
        },
        validate: {
          title: 'GET /auth/validate',
          description: 'Valida tokens de sessão do usuário e verifica status de autenticação',
          params: 'Parâmetros:',
          sessionTokenParam: 'sessionToken (string): JWT de /auth/login',
          emailParam: 'email (string): endereço de email do usuário',
          response: 'Resposta:',
          example: 'Exemplo Node.js:',
        },
        changePassword: {
          title: 'POST /auth/changePassword',
          description: 'Permite que usuários autenticados alterem suas senhas',
          params: 'Parâmetros:',
          sessionTokenParam: 'sessionToken (string): JWT de /auth/login',
          emailParam: 'email (string): endereço de email do usuário',
          newPasswordParam: 'newPassword (string): nova senha (mesmas regras de complexidade)',
          response: 'Resposta:',
          example: 'Exemplo Node.js:',
        },
        logout: {
          title: 'GET /auth/logout',
          description: 'Encerra sessões de usuário com segurança',
          params: 'Parâmetros:',
          sessionTokenParam: 'sessionToken (string): JWT de /auth/login',
          emailParam: 'email (string): endereço de email do usuário',
          response: 'Resposta:',
          example: 'Exemplo Node.js:',
        },
      },
      implementation: {
        title: 'Exemplo completo de integração no backend',
        notes: 'Notas de implementação:',
        note1: 'Armazene tokens de sessão com segurança (cookies HTTP-only recomendados)',
        note2: 'Valide sessões em rotas protegidas antes de processar requisições',
        note3: 'Trate expiração de token e renovação quando necessário',
        note4: 'Registre eventos de autenticação para monitoramento de segurança',
      },
      errorHandling: {
        title: 'Tratamento de erros e segurança',
        statusCodes: 'Códigos HTTP comuns:',
        status200: '200: Sucesso',
        status400: '400: Requisição inválida (parâmetros ausentes/inválidos)',
        status401: '401: Não autorizado (tokens inválidos, API key incorreta etc.)',
        status404: '404: Usuário não encontrado',
        status409: '409: Organização já existe (signup)',
        status500: '500: Erro de servidor',
        securityPractices: 'Boas práticas de segurança:',
        practice1: 'Sempre valide tokens JWT antes de processar requisições',
        practice2: 'Use HTTPS em todas as chamadas de API',
        practice3: 'Implemente rate limiting nos endpoints de autenticação',
        practice4: 'Armazene tokens de sessão em cookies seguros HTTP-only',
        practice5: 'Registre todas as tentativas de autenticação para monitoramento',
        practice6: 'Nunca registre dados sensíveis como senhas ou API keys',
        criticalNote: 'Crítico: todos os endpoints /auth devem ser chamados apenas pelo backend. Nunca exponha a API key nem faça chamadas do JavaScript do cliente.',
      },
    },
    features: {
      title: 'O que você recebe pronto com autenticação por email/senha',
      subtitle: 'Conecte os endpoints e nós fornecemos sessões com JWT confiável. Simples assim! 🤝',
    },
    cta: {
      title: 'Pronto para adicionar autenticação confiável por email/senha?',
      description: 'Comece seu teste grátis hoje e tenha autenticação JWT funcionando até o fim do dia.',
      createAccount: 'Criar conta grátis',
      talkToSales: 'Falar com vendas',
    },
    parameters: 'Parâmetros',
    response: 'Resposta',
    example: 'Exemplo',
    runFailureScenario: 'Executar como cenário de falha',
    failureScenarioOn: 'Cenário de falha: Ativo',
    running: 'Executando...',
    runCurlConsole: 'Executar cURL no Console',
    copied: 'Copiado!',
    copyCurl: 'Copiar curl',
    copyBackendExample: 'Copiar código do backend',
    required: 'obrigatório',
    optional: 'opcional',
    consoleRunning: 'O console está em execução...',
    consoleDemoTitle: 'Demonstração de Console Linux',
    consoleShellLabel: 'bash -- Console AuthFlow™',
    notesTitle: 'Notas',
    endpointContent: {
      session: {
        fooBar: {
          summary: 'Gere um token antiabuso de curta duração antes do cadastro ou login.',
          params: {
            identity: 'Endereço de email do usuário de autenticação.',
            apiKey: 'Chave de API da organização no painel do proprietário do AuthFlow™.',
            role: 'Função RBAC a ser codificada no token temporário. O padrão é user.',
          },
          notes: {
            expires: 'Este token expira em 45 segundos.',
            freshToken: 'Obtenha um novo token antiabuso fooBar imediatamente antes do cadastro ou login.',
          },
        },
        signUp: {
          summary: 'Crie um novo usuário de autenticação dentro da organização proprietária.',
          params: {
            foobar: 'Token antiabuso temporário retornado por /auth/fooBar.',
            email: 'Endereço de email do usuário.',
            password: 'Senha correspondente a {passwordRule}.',
            fullname: 'Nome completo do usuário de autenticação.',
            role: 'Função RBAC do usuário dentro da sua aplicação.',
            apiKey: 'Chave de API da organização.',
            disclaimed: 'Valor booleano armazenado no registro do usuário. A coleção usa true.',
          },
          notes: {
            successToken: 'Um cadastro bem-sucedido retorna um token de sessão imediatamente.',
            duplicateRole: 'Se o mesmo email e função já existirem na sua organização, a API retorna um payload 409.',
          },
        },
        login: {
          summary: 'Autentique um usuário e retorne um token de sessão ou um desafio de 2FA.',
          params: {
            foobar: 'Token antiabuso temporário retornado por /auth/fooBar.',
            email: 'Endereço de email do usuário.',
            password: 'Senha do usuário.',
            apiKey: 'Chave de API da organização.',
            role: 'Função do usuário para login RBAC.',
          },
          notes: {
            tempTokenInsteadOfToken: 'Quando o 2FA está habilitado, o login retorna tempToken em vez de token.',
            exchangeThrough2fa: 'O tempToken é então trocado por meio de um dos endpoints de verificação /auth/2fa.',
          },
        },
        validate: {
          summary: 'Valide um token de sessão para um usuário autenticado.',
          params: {
            sessionToken: 'Token de sessão JWT RS512.',
            email: 'Endereço de email do usuário.',
          },
        },
        me: {
          summary: 'Retorne o perfil atual do usuário para uma sessão válida.',
          params: {
            sessionToken: 'Token de sessão JWT RS512.',
          },
        },
        logout: {
          summary: 'Encerre a sessão do usuário autenticado atual.',
          params: {
            sessionToken: 'Token de sessão JWT RS512.',
            email: 'Endereço de email do usuário.',
          },
        },
      },
      passwordManagement: {
        forgotPassword: {
          summary: 'Solicite um email de redefinição de senha para um usuário (resposta segura contra enumeração).',
          params: {
            email: 'Endereço de email do usuário autenticado.',
            apiKey: 'Chave de API da organização.',
            role: 'Função do usuário autenticado. O padrão é user.',
          },
        },
        resetPassword: {
          summary: 'Redefina a senha de um usuário com um token de redefinição válido.',
          params: {
            token: 'Token de redefinição de senha vindo do link de email.',
            newPassword: 'Nova senha correspondente a {passwordRule}.',
          },
        },
        changePassword: {
          summary: 'Altere a senha do usuário autenticado.',
          params: {
            sessionToken: 'Token de sessão JWT RS512 atual.',
            email: 'Email codificado no token de sessão.',
            oldPassword: 'Senha atual para confirmação.',
            newPassword: 'Senha de substituição correspondente a {passwordRule}.',
          },
        },
      },
      emailVerification: {
        verifyEmail: {
          summary: 'Verifique o email do usuário usando o token enviado pelo email do AuthFlow™.',
          params: {
            token: 'Token de verificação do link de verificação por email.',
          },
          notes: {
            openedFromEmail: 'Este endpoint normalmente é aberto ao clicar no link de verificação no email.',
            frontendHostedProxy: 'O AuthFlow™ também suporta verificação hospedada no frontend via /verify-email que faz proxy desta verificação.',
          },
        },
        resendVerifyEmail: {
          summary: 'Reenvie o email de verificação quando a conta ainda não estiver verificada.',
          params: {
            foobar: 'Token temporário retornado por /auth/fooBar.',
            email: 'Endereço de email do usuário autenticado.',
            apiKey: 'Chave de API da organização.',
            role: 'Função do usuário autenticado. O padrão é user.',
          },
        },
      },
      twoFactor: {
        enable: {
          summary: 'Gere um segredo TOTP e um QR code para um usuário autenticado.',
          params: {
            sessionToken: 'Token de sessão atual.',
            email: 'Email do usuário autenticado.',
            apiKey: 'UUID da organização.',
            role: 'Função do usuário autenticado.',
          },
        },
        verifySetup: {
          summary: 'Verifique o código TOTP inicial e habilite o 2FA.',
          params: {
            sessionToken: 'Token de sessão atual.',
            email: 'Email do usuário autenticado.',
            apiKey: 'UUID da organização.',
            role: 'Função do usuário autenticado.',
            totpCode: 'Código de seis dígitos do aplicativo autenticador.',
            secret: 'Segredo TOTP retornado por /auth/2fa/enable.',
          },
        },
        disable: {
          summary: 'Desative o TOTP 2FA para um usuário autenticado.',
          params: {
            sessionToken: 'Token de sessão atual.',
            email: 'Email do usuário autenticado.',
            apiKey: 'UUID da organização.',
            role: 'Função do usuário autenticado.',
            password: 'Senha atual.',
          },
        },
        verify2fa: {
          summary: 'Troque um tempToken de login e um código TOTP por um token de sessão.',
          params: {
            tempToken: 'tempToken retornado por /auth/login quando 2FA está habilitado.',
            email: 'Email do usuário autenticado.',
            apiKey: 'UUID da organização.',
            role: 'Função do usuário autenticado.',
            totpCode: 'Código autenticador de seis dígitos.',
          },
        },
        backupEmail: {
          summary: 'Envie um OTP de backup por email usando um tempToken de login.',
          params: {
            tempToken: 'tempToken retornado por /auth/login.',
            email: 'Email do usuário autenticado.',
            apiKey: 'UUID da organização.',
            role: 'Função do usuário autenticado.',
          },
        },
        verifyEmailOtp: {
          summary: 'Troque um OTP enviado por email por um token de sessão.',
          params: {
            email: 'Email do usuário autenticado.',
            apiKey: 'UUID da organização.',
            role: 'Função do usuário autenticado.',
            emailOtp: 'Código de seis dígitos enviado por email.',
          },
        },
        recoveryCodes: {
          summary: 'Regenere códigos de recuperação para um usuário autenticado.',
          params: {
            sessionToken: 'Token de sessão atual.',
            email: 'Email do usuário autenticado.',
            apiKey: 'UUID da organização.',
            role: 'Função do usuário autenticado.',
            password: 'Senha atual.',
          },
        },
        verifyRecovery: {
          summary: 'Troque um código de recuperação por um token de sessão.',
          params: {
            email: 'Email do usuário autenticado.',
            apiKey: 'UUID da organização.',
            role: 'Função do usuário autenticado.',
            recoveryCode: 'Um dos códigos de recuperação de 8 caracteres retornados anteriormente.',
          },
        },
      },
      environment: {
        baseUrl: 'Origem pública da API.',
        apiKey: 'Chave de API do painel do proprietário. Armazenada apenas no servidor.',
        defaultRole: 'Valor de função/RBAC atribuído ao usuário autenticado.',
      },
    },
    console: {
      promptPrefix: 'owner@authflow-demo:~$',
      launching: 'Iniciando Console Linux AuthFlow™ v1.0 ...',
      kernel: 'Kernel: Linux 6.8.0-35-generic x86_64',
      curlVersion: 'curl: 8.5.0, OpenSSL: 3.0.x',
      connected: 'Conectado a api.authflow.net',
      sending: '> Enviando {method} {path}',
      waiting: '> Aguardando resposta ...',
      serverHeader: '< server: api.authflow.net',
      processExited: '[processo encerrado com código {code}]',
      status: {
        defaultSuccess: 'HTTP/1.1 200 OK (exemplo)',
        signup: {
          success: 'HTTP/1.1 201 Created (exemplo)',
          alt409: '# alt: HTTP/1.1 409 Conflict quando email+função já existem',
        },
        login: {
          success: 'HTTP/1.1 200 OK (exemplo)',
          alt2fa: '# alt: retorna payload requires2FA/tempToken quando 2FA está habilitado',
        },
        verifyEmail: {
          success: 'HTTP/1.1 200 OK (exemplo)',
          alt401: '# alt: HTTP/1.1 401 Unauthorized para token de verificação inválido ou expirado',
        },
        validate: {
          success: 'HTTP/1.1 200 OK (exemplo)',
          alt401: '# alt: HTTP/1.1 401 Unauthorized para token de sessão inválido ou expirado',
        },
        forgotPassword: {
          success: 'HTTP/1.1 200 OK (resposta segura contra enumeração)',
        },
        changePassword: {
          success: 'HTTP/1.1 200 OK (exemplo)',
          noJsonBody: '# sem corpo JSON em caso de sucesso',
        },
      },
      failure: {
        signup: {
          status: 'HTTP/1.1 409 Conflict (exemplo)',
          extra: '# cenário de falha: email+função duplicados',
        },
        login: {
          status: 'HTTP/1.1 400 Bad Request (exemplo)',
          extra: '# cenário de falha: credenciais inválidas ou incompatibilidade de função',
        },
        verifyEmail: {
          status: 'HTTP/1.1 401 Unauthorized (exemplo)',
          extra: '# cenário de falha: token de verificação vencido',
        },
        validate: {
          status: 'HTTP/1.1 401 Unauthorized (exemplo)',
          extra: '# cenário de falha: token de sessão expirado',
        },
        me: {
          status: 'HTTP/1.1 401 Unauthorized (exemplo)',
          extra: '# cenário de falha: sessionToken ausente ou inválido',
        },
        logout: {
          status: 'HTTP/1.1 401 Unauthorized (exemplo)',
          extra: '# cenário de falha: sessionToken inválido',
        },
        changePassword: {
          status: 'HTTP/1.1 401 Unauthorized (exemplo)',
          extra: '# cenário de falha: oldPassword inválida ou sessão expirada',
        },
        resendVerifyEmail: {
          status: 'HTTP/1.1 401 Unauthorized (exemplo)',
          extra: '# cenário de falha: token foobar vencido ou api_key inválida',
        },
        fooBar: {
          status: 'HTTP/1.1 400 Bad Request (exemplo)',
          extra: '# cenário de falha: identity ou api_key ausentes',
        },
        forgotPassword: {
          status: 'HTTP/1.1 400 Bad Request (exemplo)',
          extra: '# cenário de falha: email ou api_key ausentes',
        },
        resetPassword: {
          status: 'HTTP/1.1 401 Unauthorized (exemplo)',
          extra: '# cenário de falha: token de redefinição vencido',
        },
        default: {
          status: 'HTTP/1.1 400 Bad Request (exemplo)',
          extra: '# cenário de falha',
        },
      },
    },
    pageContent: {
      badge: 'Referência do produto de autenticação',
      title: 'Documentação da API AuthFlow™',
      titleAccent: 'para proprietários de organizações',
      description: 'Este Get Started documenta nossa API pública de autenticação para os usuários da sua organização. O AuthFlow™ oferece 20 rotas /auth no total: 7 rotas de sessão para autenticação e gestão de usuários, 3 rotas de gerenciamento de senha para redefinição de senha, 2 rotas de verificação de email e 8 rotas de two-factor para autenticação de dois fatores. A coleção do Insomnia disponível para download abaixo contém todas as definições de endpoint, parâmetros e exemplos de requisição compatíveis com os contratos exatos da API.',
      downloadCollection: 'Baixar coleção do Insomnia',
      createAccount: 'Criar conta de proprietário',
      cloneStarterOnGitHub: 'Clonar starter Next.js',
      starterInfoLabel: 'Informações importantes de segurança sobre o starter Next.js',
      starterWarningTitle: 'Somente para protótipos e provas de conceito',
      starterWarningPrototype: 'O authflow-nextjs-starter destina-se somente a protótipos e frontends de prova de conceito. Ele não é uma integração de navegador para produção.',
      starterWarningSecret: 'Nunca coloque uma chave de API do AuthFlow em código frontend de produção, variáveis de ambiente visíveis no navegador, recursos estáticos ou bundles de cliente. Tudo que é enviado a um navegador pode ser lido por usuários e invasores.',
      starterWarningProduction: 'Em produção, envie as solicitações de autenticação por um backend confiável no servidor ou pelo proxy ExpressJS do AuthFlow e mantenha a chave de API em variáveis de ambiente do servidor ou em um gerenciador de segredos.',
      apiKeyWarningTitle: 'Nunca exponha sua chave de API do AuthFlow em código de navegador de produção.',
      apiKeyWarningBody: 'As chaves de API devem permanecer em uma infraestrutura sob seu controle. Não as incorpore em bundles JavaScript, HTML, variáveis de ambiente públicas, recursos web móveis, logs ou solicitações de rede feitas diretamente pelo navegador. Use este proxy ExpressJS ou seu próprio backend para manter a chave no servidor.',
      integrationRulesTitle: 'Regras de integração',
      integrationRulesRules: [
        'Proprietários de organização devem chamar o AuthFlow™ somente a partir de código renderizado no servidor. Seus aplicativos de navegador devem armazenar segredos como variáveis de ambiente no servidor para chamar a API do AuthFlow™. Isso porque, ao contrário da maioria dos serviços de autenticação, o AuthFlow™ foi projetado para uso server-to-server, em conformidade geral com os padrões NIST.',
        'A chave de API do proprietário da organização (a sua) é obrigatória para as rotas principais de gerenciamento de sessão e outras rotas.',
        'O token fooBar é um token antiabuso de curta duração e deve ser obtido imediatamente antes de cada tentativa de cadastro ou login, para que esteja sempre novo e válido.',
        'Se o login retornar requires2FA, ou seja, o usuário ativou 2FA, então ele deverá concluir uma das trocas de verificação /auth/2fa documentadas para obter um token de sessão.',
      ],
      ownerAssetsTitle: 'Recursos do proprietário',
      ownerAssetsText: 'Use a coleção exata que sua equipe de implementação pode importar no Insomnia.',
      ownerAssetsCollectionName: 'AuthFlow_Consumers.yaml',
      collectionIncludes: 'A coleção inclui:',
      collectionItems: [
        '7 rotas públicas /auth de sessão',
        '3 rotas públicas /auth de gerenciamento de senha',
        '2 rotas públicas /auth de verificação de email',
        '8 rotas públicas /auth/2fa de two-factor',
        'Variáveis de ambiente para API key, role/RBAC, token de sessão, TOTP, token temporário e fluxos de código de recuperação',
      ],
      checklistTitle: 'Checklist de implementação',
      checklistSubtitle: 'Este é o fluxo recomendado para proprietários conectarem a autenticação da organização via AuthFlow™.',
      configStep: '1. Configure segredos no servidor',
      implementStep: '2. Implemente autenticação no servidor',
      connectStep: '3. Conecte seu frontend',
      connectStepSecurityNote: 'O código do navegador nunca deve armazenar segredos da API do AuthFlow™, como a API key do proprietário.',
      implementStepRules: [
        'Busque /auth/fooBar',
        'Chame /auth/signUp ou /auth/login',
        'Armazene tokens de sessão com segurança',
        'Use /auth/validate, /auth/me, /auth/changePassword e /auth/logout em rotas protegidas',
      ],
      connectStepRules: [
        'Envie formulários de login e cadastro',
        'Trate prompts de 2FA quando a API informar requires2FA',
        'Armazene sessões do app em cookies seguros',
        'Carregue o usuário atual pelas respostas dos endpoints de sessão',
      ],
      sessionEndpointsTitle: 'Endpoints de sessão',
      sessionEndpointsSubtitle: 'Estas sete rotas correspondem a authProduct.session do endpoint raiz do backend.',
      passwordMgmtTitle: 'Endpoints de gerenciamento de senha',
      passwordMgmtSubtitle: 'Estas três rotas correspondem a authProduct.passwordManagement do endpoint raiz do backend.',
      emailVerificationTitle: 'Endpoints de verificação de email',
      emailVerificationSubtitle: 'Estas duas rotas correspondem a authProduct.emailVerification do endpoint raiz do backend.',
      twoFactorTitle: 'Endpoints de two-factor',
      twoFactorSubtitle: 'Estas oito rotas correspondem a authProduct.twoFactor do endpoint raiz do backend.',
      serviceExampleTitle: 'Exemplo de serviço',
      securityRequirementsTitle: 'Requisitos de segurança',
      securityRequirements: [
        'Mantenha AUTHFLOW_API_KEY no servidor e criptografada.',
        'Prefira cookies HTTP-only seguros para a sessão da aplicação.',
        'Valide sessões AuthFlow™ antes de servir dados protegidos de usuário.',
        'Trate explicitamente respostas 400, 401, 404, 409 e 500 na sua integração.',
      ],
      readyCtaTitle: 'Pronto para conectar a autenticação da sua empresa?',
      readyCtaDescription: 'Comece com a coleção para download, implemente uma integração segura do serviço com segredos armazenados com segurança e use o assistente desta página se precisar de orientação.',
      proxyTitlePrefix: 'ExpressJS ',
      proxyTitleSuffix: ' Proxy',
      proxyDescriptionPrefix: 'Você também pode optar por usar proxy para o backend do AuthFlow a partir do seu próprio backend ExpressJS. Esse é, possivelmente, o jeito mais seguro de consumir ',
      proxyDescriptionSuffix: ' nas stacks da sua aplicação.',
      proxyDetailsRoutes: 'O proxy encaminha todas as rotas AuthFlow /auth/* e /auth/2fa/*, mantém a API key da sua organização no servidor e ajuda a evitar exposição de segredos no código de navegador.',
      proxyDetailsDeploy: 'O proxy está pronto para Vercel, suporta desenvolvimento local imediatamente e inclui exemplos práticos para cadastro, login, fluxos de senha e verificação de 2FA.',
      proxyButton: 'Ver no GitHub',
    },
  },

  agent: {
    chatbot: {
      title: 'Assistente AuthFlow™',
      inputPlaceholder: 'Pergunte sobre integração /auth ou 2FA...',
      greeting: 'Eu guio proprietários de organização pelo contrato exato auth-user do AuthFlow™. Pergunte sobre configuração da API key, endpoints /auth, fluxos 2FA, coleção Insomnia, fronteiras frontend-backend ou exclusão de conta na página Settings.',
      downloadIntro: 'Use este card de download direto para obter a coleção do proprietário e importar imediatamente.',
      downloadTitle: 'Baixar coleções do Insomnia',
      downloadButton: 'Baixar',
      noAnswer: 'Não recebi uma resposta utilizável do agente. Pergunte sobre um endpoint específico, fluxo 2FA ou etapa de integração backend.',
      error: 'Ocorreu um erro ao contatar o assistente. Você ainda pode perguntar sobre o contrato /auth, fluxos 2FA ou a coleção Insomnia e tentar novamente.',
      toolNotFound: 'Ferramenta não encontrada',
    },
    tools: {
      verificationRecoveryDescription: 'Endpoints de verificação de email e recuperação de senha',
      accountSteps: ['1. Cadastre-se como proprietário da organização em https://www.authflow.net/sign-up', '2. Crie a organização no painel do proprietário', '3. Copie a API key da organização no painel', '4. Defina os valores de role usados pelos usuários de auth', '5. Baixe a coleção Insomnia de auth-user do AuthFlow™', '6. Entregue a coleção e o contrato exato ao time que integra seu backend'],
      accountManagement: ['Para excluir permanentemente uma organização, vá para a página Settings no dashboard AuthFlow™.', 'Use Delete Account e digite DELETE para confirmar a exclusão irreversível.'],
      reminder: 'A API key do proprietário deve ficar somente no backend da empresa.',
      environmentNotes: ['Mantenha AUTHFLOW_API_KEY apenas no servidor.', 'AUTHFLOW_DEFAULT_ROLE é opcional, mas útil quando a maioria compartilha a mesma role.', 'Seu frontend deve chamar suas próprias rotas backend, não o AuthFlow™ diretamente.'],
      backendGuidance: ['Busque /auth/fooBar imediatamente antes de /auth/signUp ou /auth/login.', 'Use exatamente os nomes de parâmetros do contrato público.', 'Quando /auth/login retornar requires2FA, continue com a rota /auth/2fa adequada.', 'Valide e carregue o usuário por rotas backend, expondo apenas sua própria sessão ao frontend.'],
      insomniaContains: ['Todos os 12 endpoints públicos /auth (incluindo verify-email, resend-verify-email, forgot-password, reset-password e deleteUser)', 'Todos os 8 endpoints públicos /auth/2fa', 'Variáveis de ambiente para API key, role, fooBar token, tempToken, session token, TOTP, OTP por email e códigos de recuperação'],
      troubleshoot: {
        solutions: {
          cors: 'Se o navegador estiver chamando o AuthFlow™ diretamente, pare por ai. O navegador deve chamar seu backend, e o backend chama o AuthFlow™.',
          '401_unauthorized': 'Verifique se api_key, role e email correspondem aos valores usados em /auth/fooBar ou no cadastro do usuario.',
          token_validation: 'Use exatamente o par sessionToken e email em /auth/validate. Nao confunda sessionToken com tempToken.',
          connection_failed: 'Confirme AUTHFLOW_BASE_URL em https://api.authflow.net e conectividade do backend.',
          api_key_invalid: 'A API key do owner deve ser a chave do dashboard iniciada por af_.',
          foobar_expired: 'O fooBar expira rapido. Gere imediatamente antes de sign-up/login.',
          verification_link: 'Garanta token de verificacao valido e envie como query para /auth/verify-email.',
          password_reset: 'Primeiro chame /auth/forgot-password, depois /auth/reset-password com o token recebido por email.',
          two_factor_flow: 'Se login retornar requires2FA, use tempToken nas rotas /auth/2fa apropriadas.',
          organization_deletion: 'A exclusao permanente da organizacao e feita em Settings > Delete Account com DELETE.',
          other: 'Compare sua requisicao com o contrato publico: parametros, metodo HTTP e local de envio (query/body/header).',
        },
        commonIssues: ['Frontend chamando AuthFlow™ diretamente', 'api_key ausente ou role incorreta em /auth/fooBar ou /auth/login', 'Uso incorreto de oldPassword/newPassword em /auth/changePassword', 'Confusao entre tempToken e sessionToken', 'Token de verificacao expirado ou invalido', 'Nao chamar /auth/forgot-password antes de /auth/reset-password', 'Pular a verificacao 2FA apos requires2FA', 'Tentar excluir organizacao fora do fluxo de Settings'],
      },
    },
  },

  // Common
  comparisons: {
    hub: {
      breadcrumbRoot: 'Comparar',
      breadcrumbCurrent: 'Comparativos de produtos de autenticação',
      title: 'Comparativos de produtos de autenticação',
      description: 'Veja como o AuthFlow™ se compara às plataformas mais populares. Tabelas lado a lado para ajudar na escolha certa.',
      card: {
        firebase: {
          title: 'Firebase vs. Auth0 vs. AuthFlow™',
          description: 'Compara o Firebase Authentication do Google com a plataforma enterprise do Auth0 e a abordagem focada em devs do AuthFlow™.',
        },
        supabase: {
          title: 'Supabase vs. Auth0 vs. AuthFlow™',
          description: 'Compare a autenticação open source do Supabase com a oferta enterprise do Auth0 e o serviço enxuto do AuthFlow™.',
        },
      },
      bullets: {
        core: 'Recursos centrais e segurança',
        rbac: '2FA, RBAC e multi-tenancy',
        supabaseModel: 'Open source vs gerenciado vs focado',
        pricing: 'Preços e lock-in de fornecedor',
        dx: 'Experiência do desenvolvedor e complexidade de setup',
      },
      viewComparison: 'Ver comparação',
    },
    labels: {
      fullySupported: 'Totalmente suportado',
      partial: 'Parcial / limitado',
      notSupported: 'Não suportado',
      feature: 'Recurso',
      summary: 'Resumo',
      startFree: 'Comece grátis com AuthFlow™',
      alsoSee: 'Veja também:',
      providers: {
        firebase: 'Firebase Auth',
        supabase: 'Supabase Auth',
        auth0: 'Auth0',
        authflow: 'AuthFlow™',
      },
      categories: {
        core: 'Autenticação central',
        security: 'Segurança',
        userOrg: 'Gestão de usuários e organização',
        dx: 'Experiência do desenvolvedor',
        pricing: 'Preço e flexibilidade',
      },
    },
    features: {
      emailPassword: 'Autenticação por email e senha',
      socialLogin: 'Login social (Google, GitHub etc.)',
      magicLinks: 'Links mágicos / sem senha',
      smsPhone: 'Autenticação por SMS / telefone',
      anonymous: 'Autenticação anônima',
      jwt: 'Gerenciamento de token JWT',
      rs512: 'Assinatura com par de chaves RS512',
      twofa: 'Autenticação de dois fatores (2FA)',
      totp: 'App autenticador TOTP (Google Auth, Authy)',
      backupCodes: 'Códigos de backup 2FA',
      emailOtp: '2FA via OTP por email',
      rateLimiting: 'Rate limiting',
      emailVerification: 'Verificação de email',
      passwordReset: 'Redefinição de senha / Esqueci a senha',
      passwordComplexity: 'Regras de complexidade de senha',
      userDashboard: 'Painel de gerenciamento de usuários',
      rbac: 'Controle de acesso por função (RBAC)',
      multiTenancy: 'Multi-tenancy / Organizações',
      perOrgApiKeys: 'API keys por organização',
      auditLogs: 'Logs de auditoria/atividade',
      userBlocking: 'Bloqueio / suspensão de usuário',
      simpleRest: 'API REST simples (sem SDK obrigatório)',
      officialSdks: 'SDKs oficiais de cliente',
      customEmailTemplates: 'Templates de email personalizados',
      webhooks: 'Webhooks / callbacks de eventos',
      selfHosted: 'Opção self-hosted',
      openSource: 'Código aberto',
      apiDocs: 'Documentação de API',
      integratedDb: 'Banco integrado (PostgreSQL)',
      authOnly: 'Somente autenticação (sem banco obrigatório)',
      freeTier: 'Plano gratuito disponível',
      flatRate: 'Preço fixo previsível',
      payPerMau: 'Modelo de pagamento por MAU',
      lowLockIn: 'Baixo lock-in de fornecedor',
      lowSetup: 'Baixa complexidade de setup',
      noEcosystemBuyIn: 'Funciona sem depender de ecossistema',
    },
    notes: {
      firebase2fa: 'O Firebase exige upgrade para o Identity Platform',
      firebaseRest: 'Firebase é SDK-first; REST puro exige troca manual de tokens',
      firebaseLockIn: 'Firebase acopla fortemente ao ecossistema Google/Firebase',
      supabaseRls: 'Supabase usa políticas de segurança em nível de linha (RLS) no Postgres',
      supabaseDb: 'Supabase Auth é fortemente integrado ao banco Postgres do Supabase',
      supabaseLockIn: 'Supabase open source reduz lock-in, mas a autenticação é acoplada ao stack Postgres',
      supabaseAuthOnly: 'Supabase pode ser usado apenas para auth, mas é pensado como plataforma backend completa',
    },
    firebase: {
      breadcrumbCurrent: 'Firebase vs. Auth0 vs. AuthFlow™',
      title: 'Firebase vs. Auth0 vs. AuthFlow™',
      description: 'Comparação lado a lado entre Firebase Authentication (Google), Auth0 (Okta) e AuthFlow™ para ajudar você a escolher a camada de autenticação ideal.',
      summary: {
        firebaseTitle: 'Firebase Authentication',
        firebaseBody: 'Ideal para equipes já inseridas no ecossistema Google/Firebase. Tem bom plano grátis e integração SDK-first, mas com lock-in de ecossistema e dependência do Identity Platform para recursos avançados como 2FA.',
        auth0Title: 'Auth0',
        auth0Body: 'Conjunto de recursos mais completo entre os três: SAML, OIDC, SSO enterprise e ampla customização. Ideal para times grandes com requisitos complexos, mas com preço que cresce bastante por MAU.',
        authflowTitle: 'AuthFlow™',
        authflowBody: 'Escolha certa para quem quer autenticação por email/senha com segurança forte (JWT RS512, 2FA, RBAC) sem entrar em um grande ecossistema. API REST simples, preço previsível e setup enxuto.',
      },
      alsoSee: 'Supabase vs. Auth0 vs. AuthFlow™',
    },
    supabase: {
      breadcrumbCurrent: 'Supabase vs. Auth0 vs. AuthFlow™',
      title: 'Supabase vs. Auth0 vs. AuthFlow™',
      description: 'Comparação lado a lado entre Supabase Auth, Auth0 e AuthFlow™ para ajudar você a escolher a camada de autenticação ideal.',
      summary: {
        supabaseTitle: 'Supabase Auth',
        supabaseBody: 'Ótimo para equipes que querem backend open source e self-hostable. Supabase Auth é poderoso, com login social, magic links e integração profunda com Postgres.',
        auth0Title: 'Auth0',
        auth0Body: 'Conjunto mais completo de recursos: SAML, OIDC, SSO enterprise e customização profunda. Forte para requisitos complexos de conformidade, com custo elevado em escala.',
        authflowTitle: 'AuthFlow™',
        authflowBody: 'Escolha ideal quando você precisa de autenticação confiável por email/senha com segurança forte (JWT RS512, 2FA, RBAC) e sem lock-in de plataforma. API REST simples, preço previsível e setup mínimo.',
      },
      alsoSee: 'Firebase vs. Auth0 vs. AuthFlow™',
    },
  },

  // Common
  common: {
    loading: 'Carregando...',
    error: 'Ocorreu um erro',
    success: 'Sucesso',
    cancel: 'Cancelar',
    save: 'Salvar',
    delete: 'Excluir',
    edit: 'Editar',
    view: 'Ver',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    language: 'Idioma',
  },

  // SEO
  seo: {
    title: 'AuthFlow™ - Autenticação segura de forma simples',
    description: 'Autenticação baseada em token para aplicações web. Integração fácil, segurança empresarial e API amigável para devs.',
    keywords: ['autenticação', 'auth', 'segurança', 'API', 'autenticação por token', 'JWT', 'ferramentas para desenvolvedores', 'segurança web', 'gestão de usuários'],
  },

  // Footer (shared across pages)
  footer: {
    description: 'Autenticação simples e confiável por email/senha com tokens JWT. Confiado por desenvolvedores no mundo todo.',
    product: 'Produto',
    resources: 'Recursos',
    company: 'Empresa',
    apiReference: 'Referência da API',
    about: 'Sobre',
    support: 'Suporte',
    privacyPolicy: 'Política de privacidade',
    termsOfService: 'Termos de serviço',
    copyright: '© 2024 AuthFlow™. Todos os direitos reservados.',
  },
}
